import { RecurringEventUpdatePeriod as RecurringEventUpdatePeriodDto } from "./client";
import { RecurringEventUpdatePeriod } from "./Events.types";

export const dtoToRecurringEventUpdatePeriod = (dto: RecurringEventUpdatePeriodDto) => dto as RecurringEventUpdatePeriod;
export const recurringEventUpdatePeriodToDto = (value: RecurringEventUpdatePeriod) => value as RecurringEventUpdatePeriodDto;